export default __webpack_public_path__ + "static/media/MaterialPlastic_03.fd4b82ad.png";